import {all, spawn, call} from "redux-saga/effects";
import {loadMapSaga} from "./loadMapStyle";
import {updateLayerSaga} from "./updateLayer";
import {updateEntitySaga} from "./updateEntity";
import {deleteEntitySaga} from "./deleteEntity";
import {createEntitySaga} from "./createEntity";
import {createFeatureSaga} from "./createFeature";
import {loadGeometrySaga} from "./loadGeometryData";
import {createEntityGeometrySaga} from "./createEntityGeometry";
import {updateEntityGeometrySaga} from "./updateEntityGeometry";
import {loadLayerSaga} from "./loadLayers";
import {createLayerSaga} from "./createLayer";
import {deleteLayerSaga} from "./deleteLayer";

const sagas = [
    // loadPointSaga,
    // loadPolygonSaga,
    loadGeometrySaga, // replace point/polygon with geometry saga
    loadMapSaga,
    loadLayerSaga,
    updateLayerSaga,
    createEntitySaga,
    updateEntitySaga,
    updateEntityGeometrySaga,
    deleteEntitySaga,
    deleteLayerSaga,
    createFeatureSaga,
    createEntityGeometrySaga,
    createLayerSaga,
    // createPointSaga,
    // createPolygonSaga
];

export function* rootAsync() {
    yield all(sagas);
}

export function* rootSaga () {
    yield all(sagas.map((saga) =>
        spawn(function* () {
            while (true) {
                try {
                    yield call(saga);
                    break
                } catch (e) {
                    console.warn(e)
                }
            }
        })
    ));
}


